import { useEffect, useState } from "react";
import { Col, DatePicker, Form, Input, message, Row, Select } from "antd";
import {
  GET_BUYER_ENDPOINT,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";
import moment from "moment";
import CustomDatePicker from "common/CustomDatePicker";

const BuyerVisitDateFilterFields = ({ initialTableData }) => {
  // States
  const [buyerList, setBuyerList] = useState([]);
  const [loading, setLoading] = useState(false);

  // Antd
  const { Option } = Select;

  // Effects
  useEffect(() => {
    // Get Signal Section office, sales contract and buyer list at first load
    getAllBuyers();
  }, []);

  const getAllBuyers = async (filterValues) => {
    setLoading(true);

    const query = `${GET_BUYER_ENDPOINT}`;
    const payload = {
      ...filterValues,
    }

    const response = await getData(query, false, payload);
    if (response?.status === 200) {
      setLoading(false);
      // const filteredbuyerListData = response?.data?.data?.data?.filter(item => item.status === "Yes");
      console.log("mamuuu", response?.data?.data?.data);
      setBuyerList(response?.data?.data?.data);
    } else {
      setLoading(false);
      message.error("Error getting warehouse data");
    }
  };

  // const saveToStorage = (value, name) => {
  //   const existingFilter =
  //     JSON.parse(localStorage.getItem("cutting_filter")) || {};
  //   existingFilter[name] = value;
  //   localStorage.setItem("cutting_filter", JSON.stringify(existingFilter));
  // };
  

  return (
    <>
      <Col span={4}>
        <Form.Item label="Date" name="date">
          <CustomDatePicker
            style={{ width: "100%" }}
            onChange={(value) =>
              moment(value).format("YYYY-MM-DD")
            }
            size="small"
          />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Buyer" name="buyer_name">
          <Input size="small" />
        </Form.Item>
      </Col>
    </>
  );
};

export default BuyerVisitDateFilterFields;
